<template>
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <h2 class="pg_title">
            <span>{{ pageTitle }}</span>
        </h2>
        <!-- //contents_head -->

        <!-- srchTop_wrap -->
        <knowledge-search
            v-if="getCondition !== null"
            :boardId="getBoardId"
            :condition="getCondition"
            @current-page="setCurrentPage"
        />
        <!-- //srchTop_wrap -->

        <!-- Grid -->
        <div v-if="isLoading"></div>
        <div v-else>
            <div class="grid_wrap" v-resize="setGridResizeColumn">
                <knowledge-list-grid
                    :gridId="gridId"
                    :data="gridData"
                    :columns="columns"
                    :options="options"
                    :pageOptions="pageOptions"
                    :click="contentClick"
                    :isTotalCount="true"
                    @grid-total-count="setTotalCount"
                />
            </div>
            <div class="paginate">
                <sdl-pagination
                    align="center"
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="movePage"
                />
            </div>
        </div>
    </div>
</div>
<!-- contents -->
</template>

<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import resize                               from 'vue-resize-directive'
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLPagination                        from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';
import KnowledgeSearch                      from '~vb/knowledge/KnowledgeSearch';
import KnowledgeListGrid                    from '~vb/knowledge/KnowledgeListGrid';

import KnowledgeAttachFilePopup             from '~vb/knowledge/popup/KnowledgeAttachFilePopup';
import KnowledgeASCHitCountPopup            from '~vb/knowledge/popup/KnowledgeASCHitCountPopup';
import KnowledgeContentsPopup               from '~vb/knowledge/popup/KnowledgeContentsPopup';

// list 에서 쓰이는 아이콘 이미지 경로
const ICON_IMG = {
    favorite:   { on: '/static/images/ico_favorite_on.png',     off: '/static/images/ico_favorite_off.png'},
    recommend:  { on: '/static/images/ico_like_on.png',         off: '/static/images/ico_like_off.png'},
    file:       { on: '/static/images/ico_attach.png',          off: ''}
};

// ToastGrid image icon renderer
class CustomImageRenderer {
    constructor(props) {
        const el = document.createElement('img'),
              em = document.createElement('em');
        const { imgType } = props.columnInfo.renderer.options;
        let onImg = '', offImg = '';

        // renderer by column type
        switch(imgType) {
            case 'favorite' : onImg = ICON_IMG.favorite.on,     offImg = ICON_IMG.favorite.off;     break;
            case 'recommend': onImg = ICON_IMG.recommend.on,    offImg = ICON_IMG.recommend.off;    break;
            case 'file'     : onImg = ICON_IMG.file.on,         offImg = ICON_IMG.file.off;         break;
            default         : break;
        };

        let isImg = false;
        if(!SDLUtil.isNull(props.value)) {
            if(props.value === 'Y' || props.value > 0 || props.value === true) isImg = true;
        }

        el.src = isImg ? onImg : offImg;
        if(imgType === 'recommend') {
            const div = document.createElement('div');
            div.appendChild(el);

            //if(props.value > 0) {
                em.className = 'like_count';
                em.setAttribute('data-val', props.value);
                // 숫자가 많아질 경우 -> K, M, B, T 단위 적용
                // em.innerText = StringUtil.formatToUnits((rops.value, 0);
                em.innerText = StringUtil.numberFormat(props.value);
                div.appendChild(em);
            //};

            this.el = div;

        } else {
            this.el = el;
        }
    }

    getElement() {
        return this.el;
    }
};

// ToastGrid subject renderer
class CustomTitleRenderer {
    constructor(props) {
        const el = document.createElement('div');
        el.className = "tui-grid-cell-content";

        const em = document.createElement('em'),
              imEm = document.createElement('em');

        let title = props.value || 'Untitled';

        // Read, Hot, New, Update
        if(title.indexOf('@R@') > -1) {
            em.className = "textbgbox_recommend";
            em.innerText = "R";
            title = title.replace('@R@', '');
            el.appendChild(em);

        } else if(title.indexOf('@H@') > -1){
            em.className = "textbgbox_hot";
            em.innerText = "H";
            title = title.replace('@H@', '');
            el.appendChild(em);

        } else if(title.indexOf('@N@') > -1){
            em.className = "textbgbox_new";
            em.innerText = "N";
            title = title.replace('@N@', '');
            el.appendChild(em);

        } else if(title.indexOf('@U@') > -1){
            em.className = "textbgbox_update";
            em.innerText = "U";
            title = title.replace('@U@', '');
            el.appendChild(em);
        }

        // Important, Must Read
        if(title.indexOf('@I@') > -1) {
            imEm.className = "textcolor_important";
            imEm.innerText = "["+ SDLUtil.getMsgProp('FIELD.GLOBAL.IMPORTANT') +"]";
            title = title.replace('@I@', '');
            title = title.replace('@M@', '');   // Important, Must Read 중복 방지
            el.appendChild(imEm);

        } else if(title.indexOf('@M@') > -1) {
            imEm.className = "textcolor_must";
            imEm.innerText = "["+ SDLUtil.getMsgProp('FIELD.GLOBAL.MUSTREAD') +"]";
            title = title.replace('@M@', '');
            el.appendChild(imEm);
        }

        title = SDLUtil.convertHtml(title);
        el.appendChild(document.createTextNode(title));

        this.el = el;
    }

    getElement() {
        return this.el;
    }
};

export default {
    name : 'SvcToolList',
    data() {
        return {
            isLoading: true,
            condition: null,
            pageTitle: '',

            headerList: [],

            gridId: 'grid_' + String(this.boardId),
            columns: [],
            options: {},
            pageOptions: {},
            gridData:  [],
            searchFormData: {},

            // Prevent grid click event
            rtnCols: ['ATTACH_CNT'],
            // AS-IS Knowledge.xml line 1327 - ORDER BY surported
            sortableCols: [
                'MODEL', 'PRD_CATEGORY_CD1', 'PRD_CATEGORY_CD2', 'PRD_CATEGORY_CD3',
                'KNOWLEDGE_TITLE', 'REG_USER_NO', 'REG_DT', 'CHANNEL', 'HIT_COUNT'
            ],
            // AS-IS ListSearch.jsp line 353 - BoardId for ASC account no popup list
            boardListForHitsPopup: [
                '8248','9242','9243','9244','9245','9248','9249','9251','9287','10205','10208','13156','13258','13160','13162',
            ],

            totalCount: 0,
            currentPage: 1,
            perPage: 20 // knowledgeManager fix
        }
    },
    directives: { resize },
    computed: {
        ...mapGetters({
            params: 'getParams',
            menus: 'getMenus',
            userCorpCd: 'getCorpCd',
            userRoles: 'getRoles',
        }),
        getIcon() {
            return this.icon;
        },
        getBoardId() {
            return '25480';     // SVC Tool
        },
        getCondition() {
            return this.condition;
        },
        getUserRole() {
            return this.userRoles || [];
        },
    },
    components: {
        'skp-breadcrumbs'       : SKPBreadcrumbs,
        'knowledge-list-grid'   : KnowledgeListGrid,
        'knowledge-search'      : KnowledgeSearch
    },
    methods: {
        initLoad() {
            SDLUtil.showLoadingBar(true);
            const params = {
                BOARD_ID: this.getBoardId,
            };
            return SDLUtil.postForm(`/basis/knowledge/getListKnowledgeHeader.skp`, params)
                .then(data => {
                    Vue.$log.info('▶ SvcToolList.vue initLoad grid response => ', data);
                    let headers = data.header.rowData || [];
                    let cond = data.condition.rowData || [];

                    this.headerList = headers;
                    this.columns = this.getDynamicCols();

                    return {
                        condition: cond[0],
                        BOARD_ID: data.BOARD_ID
                    };
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        // 그리드 컬럼 percent resize 용
        getDynamicCols() {
            let headers = this.headerList || [], headerList = [];
            // 접속 Device가 모바일 유형인 경우, 제목과 첨부파일로만 헤더 설정
            if( SDLUtil.isMobile() ) {
                // mobile
                if(headers.length > 0) {
                    headers = _.sortBy(headers, ['HEADER_ORDER']);
                    for(let header of headers) {
                        if(header.HEADER_COLUMN == 'KNOWLEDGE_TITLE') {
                            headerList.push({
                                header: header.HEADER_NAME,
                                name: header.HEADER_COLUMN,
                                align: header.HEADER_ALIGN,
                                ellipsis: true,
                                width: this.getMobColumnSize(100),
                                renderer: { type: CustomTitleRenderer }
                            });

                            break;
                        }
                    };

                    // 첨부파일
                    headerList.push({
                        header: ' ', name: 'ATTACH_CNT', align: 'center', width: 80,
                        renderer: { type: CustomImageRenderer, options: { imgType : 'file' } }
                    });
                };

            // 그 외
            } else {
                // desktop, tablet
                if(headers.length > 0) {
                    // 모델
                    headerList.push({
                        header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'),
                        name: 'MODEL', align: 'center', width: 140, resizable: true, sortable: true
                    });

                    // 헤더 for loop
                    headers = _.sortBy(headers, ['HEADER_ORDER']);
                    for(let header of headers) {
                        // 헤더 컬럼이 DISPLAY_YN 인 경우, 권한 체크
                        if(header.HEADER_COLUMN == 'DISPLAY_YN') {
                            if(
                                // Admin 유저 전용 컬럼
                                this.getUserRole.find(
                                    r => r === `${constants.SYSTEM_ADMIN}`
                                      || r === `${constants.GBM_ADMIN}`
                                      || r === `${constants.RHQ_ADMIN}`
                                      || r === `${constants.SUB_ADMIN}`
                                )
                            ) {
                                headerList.push({
                                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.DISPLAY'),
                                    name: header.HEADER_COLUMN,
                                    align: header.HEADER_ALIGN,
                                    width: this.getColumnSize(header.HEADER_WIDTH),
                                    resizable: true,
                                    sortable: true
                                });
                            }

                        } else {
                            let returnCols = this.rtnCols,
                                includeBoardNo = false,
                                isTitle = false;

                            // 헤더 컬럼에 따라 이벤트 분기
                            if(header.HEADER_COLUMN == 'HIT_COUNT') {
                                // 클릭 이벤트 컬럼 재정의 (기본 컬럼 + HIT_COUNT)
                                if(this.boardListForHitsPopup.find( b => b === this.boardId )) {
                                    returnCols.push(header.HEADER_COLUMN);
                                    this.rtnCols = returnCols;
                                    includeBoardNo = true;
                                }

                            } else if(header.HEADER_COLUMN == 'KNOWLEDGE_TITLE') {
                                isTitle = true;
                            }

                            headerList.push({
                                header: header.HEADER_NAME,
                                name: header.HEADER_COLUMN,
                                align: header.HEADER_ALIGN,
                                width: this.getColumnSize(header.HEADER_WIDTH),
                                className: includeBoardNo ? 'ftColor' : '',
                                resizable: true,
                                sortable: _.includes(this.sortableCols, header.HEADER_COLUMN) ? true : false,
                                renderer: isTitle ? { type: CustomTitleRenderer } : null
                            });
                        }
                    };

                    // 첨부파일
                    headerList.push({
                        header: ' ', name: 'ATTACH_CNT', align: 'center', width: 80, resizable: true,
                        renderer: { type: CustomImageRenderer, options: { imgType : 'file' } }
                    });
                };
            };

            return headerList;
        },
        getMobColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('grid_wrap').length ? document.getElementsByClassName('grid_wrap')[0].clientWidth - 16 : 1000;
            return Math.floor((gridWrapSize - 80) / (100 / size));
        },
        getColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('grid_wrap').length ? document.getElementsByClassName('grid_wrap')[0].clientWidth - 16 : 1000;
            return Math.floor((gridWrapSize - 230) / (100 / size));
        },
        setGridResizeColumn(e) {
            EventBus.$emit('knowledge-grid-set-column', this.getDynamicCols());
        },
        // 그리드 컬럼 percent resize 용

        // 페이지 이동
        movePage(pageNo) {
            // EventBus 를 통해 이벤트를 호출한다. 해당 이벤트는 KnowledgeSearch.vue 에서 응답한다.
            EventBus.$emit('knowledge-page-search', pageNo);
            this.currentPage = pageNo;
        },
        // 총 합계 설정
        setTotalCount(totCnt) {
            this.totalCount = totCnt;
        },
        // 현재 페이지 설정
        setCurrentPage(page) {
            this.currentPage = page;
        },
        // 컨텐츠 클릭 이벤트
        contentClick(e, rowData, grid) {
            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
            let row = rowData.find(function(r){ return r.rowKey === e.rowKey });
            let knowledgeId = row['KNOWLEDGE_ID'] || '';

            // 컬럼별 이벤트 실행
            if (this.rtnCols.find(c => c === colNm)) {
                // Attach event
                if(colNm === 'ATTACH_CNT') {
                    let attachCnt = row['ATTACH_CNT'] || 0;
                    if(attachCnt > 0) {
                        SDLUtil.show(
                            KnowledgeAttachFilePopup,
                            {
                                title: SDLUtil.getMsgProp('FIELD.GLOBAL.ATTACH.FILE'), // Attach Files
                                knowledgeId: knowledgeId,
                            },  // component params
                            {
                                height: 'auto'
                            }   // dialog params
                        );
                    }

                // Hit count evnet
                } else if( colNm === 'HIT_COUNT' && this.rtnCols.find( c => c === colNm ) ) {
                    if(knowledgeId !== null) {
                        SDLUtil.show(
                            KnowledgeASCHitCountPopup,
                            { title: SDLUtil.getMsgProp('FIELD.GLOBAL.ASC_CODE'), boardId: this.getBoardId, knowledgeId: knowledgeId },
                            { height: 'auto' }
                        );
                    }
                }

            // default event -> call detail page
            } else {
                if(knowledgeId !== null) {
                    window.scrollTo(0, 0);
                    const params = {
                        knowledgeId: knowledgeId,
                        boardId: this.getBoardId
                    };

                    return this.$router.push({ name: 'GSPNConKnowledgeDetail', query: params });
                }
            }
        }
    },
    created() {
        let body = document.getElementsByTagName('body')[0];
        if(!body.classList.contains('fullpage_Wrap')) body.classList.add('fullpage_Wrap');
        /**
         * 권한 없는 유저가 들어올 때, 권한 없음 표시 필요
         */
        this.initLoad()
            .then((initObj) => {
                const menuObj = MenuUtil.menuScanByUrl('/knowledgeList.skp?BOARD_ID=' + this.getBoardId, this.menus);
                const menu = menuObj.filter(function(m){ return m.currMenu; })[0];
                store.commit(
                    'PARAMS',
                    Object.assign(
                        this.params,
                        {
                            menuId : menu.menuId,
                            menuPid : menu.menuPid || '',
                            menuGrpCd : menu.menuGrpCd || '',
                            menuGrpDetailCd : menu.menuGrpDetailCd || '',
                            creationYn : menu.creationYn
                        }
                    )
                );

                this.pageTitle = menu.menuNm + '-' + SDLUtil.getMsgProp('BUTTON.GLOBAL.LIST') || '';
                let initBoardId = initObj.BOARD_ID || "";
                if(SDLUtil.isNull(initBoardId)) {
                    SDLUtil.alert({
                        msg: 'MESSAGE.DATA.FIND.NODATA',
                        okLabel: 'BUTTON.GLOBAL.CONFIRM',
                        onOkEvt: () => {
                            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/no_auth` });
                        }
                    });
                };

                // initialized function
                if(initObj.condition !== null) {
                    this.condition = initObj.condition;
                    this.isLoading = false;
                };

                SDLUtil.showLoadingBar(false);
            })
            .catch(err => {
                SDLUtil.errorAlert(err);
                SDLUtil.showLoadingBar(false);
            });
    },
    mounted() {
        this.$nextTick(() => {
            // 200506 컨텐츠 상세에서 뒤로가기를 하였을 경우, 하단 추천 팝업이 사라지지 않음 -> 강제로 숨김 처리 이벤트 실행
            EventBus.$emit('knowledge-recommend-hide');
        });

        Vue.$log.info("▶ SvcToolList.vue mounted() => [BoardID] : ", this.getBoardId, ", [Page Name] : ", this.pageTitle);
    }
};
</script>

<style>
.bgColor { background-color: #DCF0FF }
.ftColor { color: dodgerblue!important; font-weight: bold!important; }
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/gspnCon/SvcToolList.vue